import { ComboField } from '@components/Fields/ComboField';
import { FloatField } from '@components/Fields/FloatField';
import { FixedFilterPanel } from '@components/FixedFilterPanel';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IFilter } from '@hooks/useFilter';
import { MenuItem } from '@material-ui/core';
import { IComboContratoClienteStatus } from '@model/ContratoClienteStatus';
import { IComboEmpresa } from '@model/Empresa';
import { IComboOperadora } from '@model/Operadora';
import { IRelatorioValorFranquiaPlanosFilter } from '@services/Relatorios/ValorFranquiaPlanos';
import React from 'react';

export type RelatorioValorFranquiaPlanosFilterProps = {
    filter: IFilter<IRelatorioValorFranquiaPlanosFilter>
    isLoading: boolean
    operadoraCombo: IComboOperadora
    empresaCombo: IComboEmpresa
    contratoClienteStatusCombo: IComboContratoClienteStatus
}

export function RelatorioValorFranquiaPlanosFilter ({ filter, isLoading, empresaCombo, operadoraCombo, contratoClienteStatusCombo }: RelatorioValorFranquiaPlanosFilterProps) {
    const handleReset = React.useCallback(() => {
        filter.resetFilter();
    }, [filter]);

    return (
        <FixedFilterPanel
            onSearch={filter.handleFilterRequest}
            onClear={handleReset}
            disabled={isLoading}
        >
            <HorizontalGrid spacing={1}>
                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.empresaId}
                        label="Empresa"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key="0" value="0">Todas</MenuItem>
                        { empresaCombo.createOptions() }
                    </ComboField>
                </GridItem>

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.operadoraId}
                        label="Operadora"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key="0" value="0">Todas</MenuItem>
                        { operadoraCombo.createOptions() }
                    </ComboField>
                </GridItem>

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.contratoClienteStatusId}
                        label="Status"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key="0" value="0">Todos</MenuItem>
                        { contratoClienteStatusCombo.createOptions() }
                    </ComboField>
                </GridItem>

                <GridItem xs={2}>
                    <FloatField
                        field={filter.fields.valorPlanoDe}
                        label="Vlr. Plano de"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <FloatField
                        field={filter.fields.valorPlanoAte}
                        label="Vlr. Plano até"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <FloatField
                        field={filter.fields.franquiaGbDe}
                        label="Franquia GB de"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <FloatField
                        field={filter.fields.franquiaGbAte}
                        label="Franquia GB até"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>
            </HorizontalGrid>
        </FixedFilterPanel>
    )
}